import { DataType } from '@/screens/Order/Pages/EditOrder/components/ProductRequirementForm/measurement.column'
import { AQL_TYPE } from '@/constant/aql'
import HeaderComponent from '@/screens/SystemConfigure/Components/HeaderComponent/HeaderComponent'
import PopUpMenu from '@/screens/SystemConfigure/Components/PopUpMenu/PopUpMenu'
import ToolbarComponent from '@/screens/SystemConfigure/Components/ToolbarComponent/ToolbarComponent'
import { Space } from 'antd'
import Table, { ColumnsType } from 'antd/lib/table'
import { useEffect, useState } from 'react'
import AddInspectionAQLModal from './AddInspectionAQLModal/AddInspectionAQLModal'
import './InspectionAQL.style.less'
import useMasterData from '@/hook/MasterData'
import { useMutation, useQuery } from 'react-query'
import {
  deletePropertyValue,
  getInspectionAQL,
} from '../../DataManagement.transform'
import { isEmptyValue } from '@/utils/common'
import { debounce } from 'lodash'
import { useHasMeasurementAql } from '@/hook/useMeasurementAql'


function InspectionAQL() {
  const [modalInspectionAQL, setModalInspectionAQL] = useState(false)
  const [selectedProperty, setselectedProperty] = useState(null)
  const [selectedItem, setselectedItem] = useState(null)
  const [page, setpage] = useState(1)
  const [search, setsearch] = useState('')
  const { data } = useMasterData()

  const hasMeasurementAqlSetting = useHasMeasurementAql()

  useEffect(() => {
    const tmpSelectedProperty = data?.find((item) => item.name == 'aql')
    setselectedProperty(tmpSelectedProperty)
  }, [data])

  const onEdit = (item) => {
    setselectedItem(item)
    setModalInspectionAQL(true)
  }

  const onAdd = () => {
    setselectedItem(null)
    setModalInspectionAQL(true)
  }

  const transformData = (data) => {
    return data?.map((item: any) => {
      const tmp = !isEmptyValue(item.value) ? JSON.parse(item.value) : null
      return {
        ...item,
        name: tmp?.name,
        inspection_level: tmp?.inspection_level,
        aql_type: tmp?.aql_type,
        critical_level: tmp?.critical_level,
        major_level: tmp?.major_level,
        minor_level: tmp?.minor_level,
        other_level: tmp?.other_level,
        min_sample_size: tmp?.min_sample_size,
        max_sample_size: tmp?.max_sample_size,
      }
    })
  }

  const {
    data: value,
    isLoading,
    refetch,
  } = useQuery(
    ['inspectionAQL', page, search],
    async () => {
      const tmp = {
        reference_id: selectedProperty?.id,
        name: 'aql',
        page_size: 10,
        page_number: page,
        search: search,
      }
      return await getInspectionAQL(tmp)
    },
    {
      enabled: !!selectedProperty,
    }
  )

  const deleteMutation = useMutation(async (id: string) => {
    await deletePropertyValue(id)
  })

  const onDeleteValue = async (id: string) => {
    await deleteMutation.mutateAsync(id)
    await refetch()
  }

  const columns: ColumnsType<DataType> = [
    {
      title: 'id',
      dataIndex: 'id',
      key: 'id',
      // sorter: (a: any, b: any) => a.name.length - b.name.length,
      className: 'hide-column',
    },
    {
      title: 'NAME',
      dataIndex: 'name',
      key: 'name',
      align: 'left',
      render: (value, record: any) => {
        return (
          <p>
            {value}
            <span style={{ color: '#adadad' }}>
              {record?.is_default && ' (Default)'}
            </span>{' '}
          </p>
        )
      },
      // sorter: (a: any, b: any) => a.name.length - b.name.length,
    },
    {
      title: 'LEVEL',
      dataIndex: 'inspection_level',
      key: 'inspection_level',
      // sorter: (a: any, b: any) => a.name.length - b.name.length,
    },
    ...(hasMeasurementAqlSetting ? [
      {
        title: 'TYPE',
        dataIndex: 'aql_type',
        key: 'aql_type',
        render: (value: string) => {
          const found = AQL_TYPE.find((t) => t.value === value)
          return found ? found.label : (value || 'Default')
        },
      }
    ] : []),
    {
      title: 'CRITICAL',
      dataIndex: 'critical_level',
      key: 'critical_level',
      // sorter: (a: any, b: any) => a.name.length - b.name.length,
    },
    {
      title: 'MAJOR',
      dataIndex: 'major_level',
      key: 'major_level',
      // sorter: (a: any, b: any) => a.name.length - b.name.length,
    },
    {
      title: 'MINOR',
      dataIndex: 'minor_level',
      key: 'minor_level',
      // sorter: (a: any, b: any) => a.name.length - b.name.length,
    },
    {
      title: 'ACTION',
      key: 'action',
      render: (_, record: any) => (
        <Space size="middle">
          <PopUpMenu
            onEdit={() => onEdit(record)}
            onDelete={() => {
              onDeleteValue(record.id)
            }}
          />
        </Space>
      ),
    },
  ]

  const onSearch = debounce(async (value) => {
    setsearch(value)
  }, 500)

  return (
    <>
      <HeaderComponent title="Inspection AQL" />
      <ToolbarComponent
        onAdd={onAdd}
        onSearch={onSearch}
        buttonText="New AQL"
      />
      <Table
        columns={columns}
        dataSource={transformData(value?.data)}
        loading={isLoading}
        pagination={{
          current: page,
          total: value?.pagination?.total_record,
          pageSize: 10,
          onChange: (page) => setpage(page),
        }}
      />
      {modalInspectionAQL && (
        <AddInspectionAQLModal
          visible={modalInspectionAQL}
          onClose={() => setModalInspectionAQL(false)}
          data={selectedItem}
          propertyId={selectedProperty?.id}
        />
      )}
    </>
  )
}

export default InspectionAQL
